import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { NotificationsService } from '..'

export const NOTIFICATIONS_COUNT_RQ_KEY = 'notifications-count'

export const getNotificationsCountOptions = (projectId: string) => {
  return queryOptions({
    queryKey: [NOTIFICATIONS_COUNT_RQ_KEY, projectId],
    queryFn: () => NotificationsService.getNotificationsCount(projectId),
    placeholderData: keepPreviousData,
    select: response => response.data,
    enabled: Boolean(projectId),
    refetchInterval: 60 * 1000
  })
}

export const useNotificationsCount = () => {
  const { selectedProjectId } = useSelectedProjectStore()

  return useQuery(getNotificationsCountOptions(selectedProjectId))
}
